import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authTokenSelector } from '../../../../selectors/auth';
import { CexAPI } from '../../../../store/createStore';
import { actionCheckCEX } from '../../../../actions/cex_trading';
import Button from '../../../../molecules/Button';
import ModalInput from './ModalInput';
import { actionCreateNotification } from '../../../../actions/notifications';
import { ECEXExchangeName } from '../../../../reducers/cex_trading';
import { EXCHANGE_MAPPING } from './ExchangeSelector/helpers';

interface IConnectExchangeProps {
  exchange: ECEXExchangeName;
  reset(): void;
}

const ConnectExchange = ({ exchange, reset }: IConnectExchangeProps) => {
  const [api, setApi] = useState('');
  const [secret, setSecret] = useState('');
  const [error, setError] = useState(false);
  const authToken = useSelector(authTokenSelector);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onConnect = () => {
    setLoading(true);
    CexAPI.activateAPIKey(exchange, api, secret, authToken!).then((res) => {
      if (res.success) {
        dispatch(
          actionCreateNotification({
            kind: 'info',
            message: `Successfully connected to the ${exchange}`,
          })
        );
        setLoading(false);
        dispatch(actionCheckCEX());
        reset();
      } else {
        dispatch(
          actionCreateNotification({
            kind: 'error',
            message: `Could not connect to ${exchange}, please check key, secret, permissions`,
          })
        );
        setLoading(false);
        setError(true);
      }
    });
  };

  return (
    <div className='cex_wallet select_wallet__appear_box'>
      <div className='cex_wallet__connect'>
        <ModalInput
          label='Token'
          value={api}
          setValue={setApi}
          loading={loading}
          info='Enter your<br>API key'
          icon='icon-add-api'
          placeholder='Your token'
        />
        <ModalInput
          label='Secret key'
          value={secret}
          setValue={setSecret}
          error={error ? 'You entered wrong key' : undefined}
          resetError={() => setError(false)}
          loading={loading}
          info='Enter your<br>secret key'
          icon='icon-alert-circle'
          placeholder='e.x 1234567890...'
          type='password'
        />
      </div>

      <div className='cex_wallet__connect__btn'>
        <Button
          text={`Connect ${EXCHANGE_MAPPING[exchange].label} API Key`}
          action={onConnect}
          size='s'
          variant='primary'
          loading={loading}
        />
      </div>
    </div>
  );
};

export default ConnectExchange;
